import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TrainingSharedFacade } from '@medsurf/flat-facades';

@Component({
    selector: 'medsurf-quiz-end',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './quiz-end.component.html',
    styleUrls: ['./quiz-end.component.scss'],
    standalone: false
})
export class QuizEndComponent {
  /**
   * Constructor
   *
   * @param trainingSharedFacade
   */
  public constructor(public trainingSharedFacade: TrainingSharedFacade) {}

  /* TODO Quiz Result
  ngOnInit() {
    this.matomo.trackQuizEnd(this.quizService.getSlideIds(), this.correctPercentage);
  }
  */
}
